// src/features/frighi/useCryoList.js
import { useEffect, useState } from "react";
import { getCryoList } from "./api";

export function useCryoList(aziendaId = null, { refreshMs = 60000 } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let stop = false;
    async function load() {
      try {
        setLoading(true);
        const rows = await getCryoList(aziendaId);
        if (!stop) setData(rows);
      } catch (e) {
        if (!stop) setError(e.message || String(e));
      } finally {
        if (!stop) setLoading(false);
      }
    }
    load();
    if (refreshMs) {
      const t = setInterval(load, refreshMs);
      return () => { stop = true; clearInterval(t); };
    }
    return () => { stop = true; };
  }, [aziendaId, refreshMs]);

  return { data, loading, error, setData };
}
